import { set, omit } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import {
  createFetchManyHandler,
  createDeleteHandler
} from '../../../../helpers/reducerRoutineCrudHandler';
import {
  paginationState,
  resetPaginationState
} from '../../../../helpers/pagination';
import { deleteROPicklist, fetchROPicklists } from '../../sagas/routines';
import {
  ROPicklistOnClear,
  ROPicklistOnChangePage,
  ROPicklistOnChangeOrder,
  ROPicklistRemoveItem
} from '../../actions/ro-picklist';

const initialState = {
  all: {},
  fetching: false,
  fetched: false,
  fetchingError: null,
  saving: false,
  saved: false,
  savingError: null,
  deleting: false,
  deleted: false,
  deletingError: null,
  pagination: paginationState(),
  order: 'id:asc'
};

const ROPicklistOnClearHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    all: {},
    pagination: resetPaginationState(state.pagination)
  })
});

const ROPicklistOnChangePageHandler = action => ({
  [action.toString()]: (state, { payload: page }) =>
    set('pagination.currentPage', page, state)
});

const ROPicklistOnChangeOrderHandler = action => ({
  [action.toString()]: (state, { payload: order }) => set('order', order, state)
});

const ROPicklistRemoveItemHandler = action => ({
  [action.toString()]: (state, { payload: id }) => ({
    ...state,
    all: omit(id, state.all)
  })
});

export default createReducer(initialState, {
  ...createFetchManyHandler(fetchROPicklists),
  ...createDeleteHandler(deleteROPicklist),
  ...ROPicklistOnClearHandler(ROPicklistOnClear),
  ...ROPicklistOnChangePageHandler(ROPicklistOnChangePage),
  ...ROPicklistOnChangeOrderHandler(ROPicklistOnChangeOrder),
  ...ROPicklistRemoveItemHandler(ROPicklistRemoveItem)
});
